/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IAllergyLegend } from 'app/shared/model/allergy-legend.model';
import { IAllergySymptom } from 'app/shared/model/allergy-symptom.model';

export interface IUserAllergies {
  id?: string;
  active?: boolean;
  endDate?: number | null;
  microSec?: number;
  startDate?: number;
  timestampentry?: number;
  lastupdated?: number;
  cursor?: number;
  glucoUser?: IGlucoUser;
  allergy?: IAllergyLegend;
  sympton?: IAllergySymptom;
}

export const defaultValue: Readonly<IUserAllergies> = {
  active: false,
};
